import React from 'react';
import './TestimonialsSection.css';

const testimonials = [
  {
    name: 'Priya Sharma',
    role: 'Fitness Enthusiast',
    avatar: 'PS',
    rating: 5,
    quote: 'Wary has completely changed how I manage my health. The health score feature keeps me motivated, and booking lab tests is now effortless!',
  },
  {
    name: 'Rajesh Kumar',
    role: 'Working Professional',
    avatar: 'RK',
    rating: 5,
    quote: 'As someone with a busy schedule, Wary makes it easy to keep track of my health reports and get timely reminders for follow-ups.',
  },
  {
    name: 'Dr. Anita Desai',
    role: 'General Physician',
    avatar: 'AD',
    rating: 5,
    quote: 'I recommend Wary to all my patients. The digital reports and health trends make it easier for me to track their progress over time.',
  },
];

const TestimonialsSection: React.FC = () => {
  return (
    <section className="testimonials">
      <div className="container">
        <h2 className="section-title">What Our Users Say</h2>
        <p className="section-subtitle">
          Join thousands of happy users who trust Wary with their health.
        </p>

        <div className="testimonials__grid">
          {testimonials.map((t, index) => (
            <div key={index} className="testimonials__card">
              <div className="testimonials__stars">
                {Array.from({ length: t.rating }, (_, i) => (
                  <span key={i}>&#9733;</span>
                ))}
              </div>
              <p className="testimonials__quote">&ldquo;{t.quote}&rdquo;</p>
              <div className="testimonials__author">
                <div className="testimonials__avatar">{t.avatar}</div>
                <div>
                  <div className="testimonials__name">{t.name}</div>
                  <div className="testimonials__role">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
